import React, { Fragment, memo } from 'react';
import PropTypes from 'prop-types';
import {
    DIBELS8,
    R3D,
    BURST,
    R3DSPANISH,
    IDEL,
    IDEL2,
    OLS_SPANISH,
    OLS,
} from '../../../constants/applications';
import Dibels8Summary from '../dibels8-summary/Dibels8Summary';
import BurstSummary from '../burst-summary/BurstSummary';
import Idel2Summary from '../idel2-summary/Idel2Summary';
import IdelSummary from '../idel-summary/IdelSummary';
import InventorySummary from '../inventory-summary/InventorySummary';
import OLSSummary from '../ols-summary/OLSSummary';
import {
    burstResultType,
    resultType,
    studentType,
    trcResultType,
} from '../../../constants/prop-types';
import { useAppContext } from '../../../common/contexts/AppContext';
import { useAppConfigContext } from '../../../common/contexts/AppConfigContext';
import TRCSummary from '../trc-summary/TRCSummary';

const BMSummary = ({ applicationsForRender, student, classId }) => {
    const {
        selectedClassData: { results },
    } = useAppContext();
    const { isLecturaLicensed } = useAppConfigContext();

    return applicationsForRender.map(appName => (
        <Fragment key={appName}>
            {appName === DIBELS8 && (
                <>
                    <Dibels8Summary student={student} classId={classId} results={results.dibels8} />
                    <InventorySummary
                        student={student}
                        classId={classId}
                        results={results}
                        applications={[DIBELS8]}
                    />
                </>
            )}

            {appName === IDEL && <IdelSummary studentGrade={student.grade} />}

            {appName === IDEL2 && (
                <>
                    {isLecturaLicensed && (
                        <Idel2Summary student={student} classId={classId} results={results.idel2} />
                    )}
                    <InventorySummary
                        student={student}
                        classId={classId}
                        results={results}
                        applications={[IDEL2]}
                    />
                </>
            )}

            {(appName === R3D || appName === R3DSPANISH) && (
                <TRCSummary student={student} classId={classId} />
            )}

            {(appName === OLS_SPANISH || appName === OLS) && (
                <OLSSummary student={student} classId={classId} results={results[OLS]} />
            )}

            {appName === BURST && (
                <BurstSummary
                    student={student}
                    dibelsResults={results.dibels8}
                    burstResults={results.burst}
                />
            )}
        </Fragment>
    ));
};

BMSummary.propTypes = {
    applicationsForRender: PropTypes.arrayOf(PropTypes.string).isRequired,
    student: studentType.isRequired,
    classId: PropTypes.string.isRequired,
    results: PropTypes.shape({
        dibels8: PropTypes.shape({
            BOY: PropTypes.objectOf(PropTypes.arrayOf(resultType)),
            MOY: PropTypes.objectOf(PropTypes.arrayOf(resultType)),
            EOY: PropTypes.objectOf(PropTypes.arrayOf(resultType)),
            PM: PropTypes.objectOf(PropTypes.arrayOf(resultType)),
        }),
        burst: PropTypes.shape({
            BOY: PropTypes.objectOf(PropTypes.arrayOf(burstResultType)),
            MOY: PropTypes.objectOf(PropTypes.arrayOf(burstResultType)),
            EOY: PropTypes.objectOf(PropTypes.arrayOf(burstResultType)),
            PM: PropTypes.objectOf(PropTypes.arrayOf(burstResultType)),
        }),
        r3d: PropTypes.shape({
            BOY: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
            MOY: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
            EOY: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
            PM: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
        }),
        r3dspanish: PropTypes.shape({
            BOY: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
            MOY: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
            EOY: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
            PM: PropTypes.objectOf(PropTypes.arrayOf(trcResultType)),
        }),
    }),
};

export default memo(BMSummary);
